import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import AboutPage from '../views/AboutPage.vue'
import PortfolioPage from '../views/PortfolioPage.vue'
import ContactPage from '../views/ContactPage.vue'
import CertificatePage from '../views/CertificatePage.vue'
import LoginPage from '../views/LoginPage.vue'
import LogoutPage from '../views/LogoutPage.vue'
import AdminPage from '../views/AdminPage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: { transition: 'slide-left' },
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
    meta: { transition: 'slide-left' },
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    component: PortfolioPage,
    meta: { transition: 'slide-left' },
  },
  {
    path: '/certificate',
    name: 'Certificate',
    component: CertificatePage,
    meta: { transition: 'slide-left' },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage,
    meta: { transition: 'slide-left' },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: { transition: 'slide-left' }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: LogoutPage,
    meta: { transition: 'slide-left' }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminPage,
    meta: { transition: 'slide-left', requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const user = localStorage.getItem('user');
    if (user) {
      next();
    } else {
      next({ path: '/login' });
    }
  } else {
    next();
  }
});

export default router
